import { useGetUserNotificationByUserIdSubscription } from 'graphql/generated/hasura';
import { useState } from 'react';
import { Notification } from '../useNotifications';
import { ActivityFilter } from '../../app/dashboard/components/provider/dashboardModules/activity/useProviderActivity';
import { getNotificationsConfig } from 'utilities/config';

export const useNotifications = (
  variables: ActivityFilter = { limit: 20, offset: 0 },
) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const { lookbackDays } = getNotificationsConfig();

  const sinceFrom =
    variables.sinceFrom ??
    new Date(
      Date.UTC(
        new Date().getUTCFullYear(),
        new Date().getUTCMonth(),
        new Date().getUTCDate() - lookbackDays,
      ),
    ).toISOString();

  const where: Record<string, unknown> = {
    status: { _in: variables.includeStatuses },
    has_priority: { _in: variables.includePriorities },
    created_at: { _gte: sinceFrom },
    activity_type: { _in: variables.activityTypes },
    is_modal: variables.isModal && { _eq: variables.isModal },
    is_toast: variables.isToast && {
      _eq: true,
    },
  };

  useGetUserNotificationByUserIdSubscription({
    variables: {
      where,
      limit: variables.limit,
    },
    fetchPolicy: 'network-only',
    onData: ({ data }) => {
      const notifications = data.data?.user_notifications ?? [];
      setNotifications(notifications);
    },
  });

  return { notifications };
};
